import React from 'react';
import { ToastContainer, ToastMessageAnimated } from "react-toastr"

const ToastMessageFactory = React.createFactory(ToastMessageAnimated);

class Toastr extends React.Component {
	componentWillReceiveProps(nextProps) {
		this.display(nextProps);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.errorData !== this.props.errorData
			|| nextProps.successData !== this.props.successData);
	}

	display = ({ successData, errorData }) => {
		if (successData === undefined && errorData === undefined)
			return;
		else if (successData !== null && successData !== undefined)
			this.success(successData);
		else if (errorData !== null && errorData !== undefined && errorData.errorMessage !== undefined && errorData.errorMessage !== null)
			this.error(errorData.errorMessage);
		else if (errorData !== null)
			this.error(errorData);
	}

	error = (message) => {
		this.refs.toastr.error(message);
	}

	success = (message) => {
		this.refs.toastr.success(message);
	}

	render() {
		return (<ToastContainer toastMessageFactory={ToastMessageFactory}
			ref="toastr"
			className="toast-top-right" />
		)
	}
}

export default Toastr;



// WEBPACK FOOTER //
// ./src/fw/components/toastr/Toastr.js